<template>
  <div>
    <Modal
      :closeable="false"
      :showModal="showLegalModal && legalTextsLoaded"
      v-if="showLegalModal && legalTextsLoaded"
    >
      <template #header>
        <div v-html="borrowerStore.getLegalTextBySlug('esignature_header')"></div>
      </template>
      <template #body >
        <div class="d-flex flex-row align-items-start pt-4">
          <input
            data-cy="esignCheckbox"
            type="checkbox"
            class="mt-1"
            name="esignature-agree"
            id="esignature-terms-agree"
            v-model="marketingSmsOptIn"
          />
          <label class="mx-1" id="esignature-terms-label"></label>
          <div class="sign-modal pl-5" data-cy="esignature-text" v-html="borrowerStore.getLegalTextBySlug('esignature')"></div>
        </div>
        <div class="d-flex flex-row align-items-start pt-4">
          <div class="sign-modal pl-5" data-cy="signup-text" v-html="borrowerStore.getLegalTextBySlug('resign_agreement')"></div>
        </div>
      </template>
      <template #footer>
        <hr />
        <div class="modal-footer d-flex flex-row-reverse pt-1 px-3 pb-4">
          <button type="button"
            @click="agreeToTerms"
            :disabled="disableSubmit"
            :class="{ 'disabled': disableSubmit}"
            class="btn btn-primary"
            data-cy="esignButton"
          >
              <span>{{ acceptButtonText }}</span>
          </button>
          <span class="py-3 px-5" role="button" @click="cancel"><strong>Cancel</strong></span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import env from '~/libs/env'
import { storeToRefs } from 'pinia'
import { useBorrowerStore } from '~/store/borrower'
import { useQuestionsStore } from '~/store/questions'
import { useRootStore } from '~/store/root'
import pageFormMixin from '~/components/Form/page-form-mixin'
import Modal from '~/components/modal.vue'

export default {
  components: {
    Modal
  },
  mixins: [
      pageFormMixin,
  ],
  async setup() {
    const legalTextSlugs = [
      'resign_agreement',
      'esignature',
      'esignature_header'
    ]
    const borrowerStore = useBorrowerStore()
    const {
      showLegalModal,
    } = storeToRefs(borrowerStore)
    const { isEmbedded } = storeToRefs(useRootStore())

    if (showLegalModal) {
      await borrowerStore.fetchLegalTextsBySlugs(legalTextSlugs)
    }

    const legalTextsLoaded = borrowerStore.hasAllLegalTextsBySlugs(legalTextSlugs)

    return {
      isEmbedded,
      legalTextsLoaded,
      borrowerStore,
      questionsStore: useQuestionsStore(),
      showLegalModal
    }
  },
  data () {
    return {
      marketingSmsOptIn: false,
      disableSubmit: false,
      acceptButtonText: 'Accept and continue',
    }
  },
  computed: {
    isNotRenewalRoute() {
      return !this.$router.currentRoute.value.path.includes('/renewal');
    },
  },
  methods: {
    async agreeToTerms () {
      this.disableSubmit = true
      if (!this.legalTextsLoaded) {
        this.borrowerStore.$patch({ signatureExpired: false })
        // Allow the borrower to move forward, but don't actually post to sign the application
        return
      }

      await this.questionsStore.saveAnswers({
        answers: {
          borrowerCanText: true,
          marketingSmsOptIn: this.marketingSmsOptIn
        }
      })
      await this.borrowerStore.signApplication()
      this.disableSubmit = false
    },
    cancel () {
      if (this.isEmbedded){
        window.parent.postMessage({
            source: 'BP',
            method: 'close',
            action: 'close',
        }, '*')
        return
      }
      return navigateTo(env('hpBaseUrl'), {
        external: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .sign-modal {
    font-size: 12px;
  }
  .modal-content {
    padding: none;
  }
</style>
